var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useMemo, useRef } from 'react';
import moment from 'moment-timezone';
import { useGetInviteesWorkingLocationQuery } from '../../generated/graphql';
// The gateway rejects requests with more ids than this (MAX_USER_IDS)
var MAX_USER_IDS = 100;
export var useInviteesWorkingLocation = function (_a) {
    var userIds = _a.userIds, startTime = _a.startTime, timezone = _a.timezone;
    var tz = timezone || moment.tz.guess();
    var dateRanges = useMemo(function () {
        if (!(startTime === null || startTime === void 0 ? void 0 : startTime.isValid()))
            return [];
        var dayStart = startTime.clone().tz(tz).startOf('day');
        var dayEnd = startTime.clone().tz(tz).endOf('day');
        return [
            {
                startTime: dayStart.toISOString(),
                endTime: dayEnd.toISOString(),
                timeZone: tz,
            },
        ];
    }, [startTime, tz]);
    var dateKey = dateRanges.length
        ? "".concat(dateRanges[0].startTime, "|").concat(dateRanges[0].endTime)
        : '';
    // tl:dr; query id refs prevent requerying office status whenever we rm a user from list
    // Accumulate every id seen for the current date so the queried set only
    // ever grows. Removing a user then leaves the query variables unchanged,
    // which Apollo answers from cache instead of refetching the whole batch.
    var queriedIdsRef = useRef({
        dateKey: dateKey,
        ids: new Set(),
    });
    var ids = useMemo(function () {
        if (queriedIdsRef.current.dateKey !== dateKey) {
            queriedIdsRef.current = { dateKey: dateKey, ids: new Set() };
        }
        userIds.forEach(function (id) {
            if (id != null)
                queriedIdsRef.current.ids.add(String(id));
        });
        return __spreadArray([], __read(queriedIdsRef.current.ids), false).sort().slice(0, MAX_USER_IDS);
    }, [userIds, dateKey]);
    var _b = useGetInviteesWorkingLocationQuery({
        skip: ids.length === 0 || dateRanges.length === 0,
        variables: { ids: ids, dateRanges: dateRanges },
    }), data = _b.data, loading = _b.loading;
    var statusByUserId = useMemo(function () {
        var statuses = {};
        data === null || data === void 0 ? void 0 : data.getUsersInOfficeDataByDay.forEach(function (result) {
            var dayData = result.byDay[0];
            if (!dayData)
                return;
            statuses[result.userId] = dayData.userInOffice ? 'in_office' : 'remote';
        });
        return statuses;
    }, [data]);
    var getStatusForUser = useCallback(function (userId) { var _a; return userId != null ? (_a = statusByUserId[String(userId)]) !== null && _a !== void 0 ? _a : null : null; }, [statusByUserId]);
    return { getStatusForUser: getStatusForUser, loading: loading };
};
